import WidgetErrorRetryPanel from './WidgetErrorRetryPanel';
import AsyncComponentErrorBoundary from '../code-splitting/AsyncComponentErrorBoundary';
import CurrentViewContainer from '../current-view/CurrentViewContainer';
import SideDockCurrentViewContainer from '../side-dock/current-view/SideDockCurrentViewContainer';
import { useAccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import { Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import DialogWindow from './DialogWindow';
import SideDockDialogWindow from '../side-dock/components/SideDockDialogWindow';
import { useBrowserWindowContext } from './BrowserWindowContext';
import { useSideDockContext } from 'conversations-visitor-experience-components/contexts/SideDockContext';
import { useDisplayMode } from 'conversations-visitor-experience-components/contexts/DisplayModeContext';
import { DOCKED } from 'conversations-internal-schema/widget-data/constants/widgetDisplayModeTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const WidgetWindow = props => {
  const {
    inline,
    isOpen,
    shouldRenderDialog,
    mobile,
    widgetLocation,
    onClose,
    onOpenAnimationStarted,
    onCloseAnimationFinished,
    onOpenAnimationFinished,
    onCloseAnimationStarted,
    usePillLauncher,
    onSetMessageTextExternally
  } = props;
  const {
    disableWidgetDialog
  } = useAccessibilityContext();
  const {
    browserWindowHeight,
    browserWindowWidth
  } = useBrowserWindowContext();
  const {
    widgetDisplayMode
  } = useDisplayMode();
  const {
    isAnimationReady
  } = useSideDockContext();
  const getDialogConfig = () => {
    if (disableWidgetDialog) {
      return {
        Wrapper: Fragment,
        props: {}
      };
    }
    if (widgetDisplayMode === DOCKED) {
      return {
        Wrapper: SideDockDialogWindow,
        props: {
          isOpen: isOpen && isAnimationReady,
          onClose,
          onEnter: onOpenAnimationStarted,
          onEntered: onOpenAnimationFinished,
          onExit: onCloseAnimationStarted,
          onExited: onCloseAnimationFinished,
          widgetLocation
        }
      };
    }
    if (!shouldRenderDialog) {
      return {
        Wrapper: Fragment,
        props: {}
      };
    }
    return {
      Wrapper: DialogWindow,
      props: {
        isOpen,
        onClose
      }
    };
  };
  const {
    Wrapper,
    props: wrapperProps
  } = getDialogConfig();
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(AsyncComponentErrorBoundary, {
      renderError: retry => /*#__PURE__*/_jsx(NavMarker, {
        name: "ERROR_WITH_RETRY",
        children: /*#__PURE__*/_jsx(WidgetErrorRetryPanel, {
          inline: inline,
          isOpen: isOpen,
          mobile: mobile,
          widgetLocation: widgetLocation,
          onClose: onClose,
          retry: retry
        })
      }),
      children: widgetDisplayMode === DOCKED ? /*#__PURE__*/_jsx(SideDockCurrentViewContainer, {
        browserWindowHeight: browserWindowHeight,
        browserWindowWidth: browserWindowWidth,
        isOpen: isOpen,
        closeWidget: onClose
      }) : /*#__PURE__*/_jsx(CurrentViewContainer, {
        browserWindowHeight: browserWindowHeight,
        browserWindowWidth: browserWindowWidth,
        inline: inline,
        isOpen: isOpen,
        onOpenAnimationStarted: onOpenAnimationStarted,
        onCloseAnimationFinished: onCloseAnimationFinished,
        onOpenAnimationFinished: onOpenAnimationFinished,
        onCloseAnimationStarted: onCloseAnimationStarted,
        closeWidget: onClose,
        usePillLauncher: usePillLauncher,
        onSetMessageTextExternally: onSetMessageTextExternally
      })
    })
  }));
};
WidgetWindow.displayName = 'WidgetWindow';
export default WidgetWindow;